/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

export default {
  name: 'medium',
  methods: {
    toString() {
      return `Medium {id: "${this.id}"}`;
    }
  },
  relations: {
    belongsTo: {
      asset: {
        localField: 'asset',
        localKey: 'assetId'
      }
    }
  }
};
